import React, { Component } from "react";
import { source } from "react-aim";
import {
  Button,
  Icon,
  Popup,
  Grid,
  Header,
  Segment,
  Divider,
  List,
  Image,
} from "semantic-ui-react";
import { dispatch } from "@rematch/core";
import { toastr } from "react-redux-toastr";
import "./Toolbar.css";
import LoadingComponent from "./../../../common/LoadingComponent";
import designerImage from "../../../../images/svg/Export/playbook.svg";
import excelImage from "../../../../images/svg/Export/excel.svg";
import CopyPlaybookModal from "../../Modal/CopyPlaybookModal";
import PlaybookInfoModal from "../../Modal/PlaybookInfoModal";
import GeneratePlaybookModal from "../../../workspace/lifecycleDesigner/DesignerPane/Practice/GeneratePlaybookModal";
import wordImage from "../../../../images/svg/Export/word.svg";
import generateAi from "../../../../images/svg/noun-ai-6480915.svg";
import ExcelPlaybookConfirmationModal from "../../../workspace/lifecycleDesigner/DesignerPane/Practice/ExcelPlaybookConfirmationModal";
import { isBlockedBySubscriptionLimit } from "../../../../helpers/subscriptionLimitCheck";
import { isBlockedByActiveGeneration } from "../../../../helpers/playbookGenerationCheck";
const _ = require("lodash");

@source({
  mouseEnter: (props, component) =>
    dispatch.app.setHelpContext("Playbook Action Icons"),
})
class ToolbarDesigner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      copying: false,
      playbookInfoModal: false,
      generatePlaybookModal:false,
      regeneratePlaybookFlag:false,
      showExcelOptions: false,
      excelExport: false,
      popupOpen: false,
    };
    this.fileUploaded = this.fileUploaded.bind(this);
  }

  handleOpen = () => {
    this.setState({ popupOpen: true });
  };

  handleClose = () => {
    this.setState({ popupOpen: false });
  };
  createPlaybook = (e) => {
    this.handleClose();
    dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    const { history } = this.props;
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookCreated,
      entity: "Playbooks",
      entityType: "Manual Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      history.push(
        `/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_pb/page/create`
      );
      dispatch.lifeCycle.setSelectedPracticeLibraryData({});
      dispatch.lifeCycle.showResourecePane(null);
      dispatch.lifeCycle.setArrangementPaneFlag(false);
      dispatch.lifeCycle.modalEditOpen(false);
      dispatch.lifeCycle.showLangingPage(false);
      dispatch.organizationUnit.fetchTeams({
        organizationId: this.props.selectedOrganisation.id,
        accountId: this.props.selectedAccount._id,
      });
    }
  };
  generatePlaybook = async (e) => {
    this.handleClose();
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    let requiredCredits = defaults.playbooksGenerated + (defaults.activitiesGenerated * 100);
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits,
      entity: "Playbooks",
      entityType: "AI Generated Playbook",
    })) {
      // blocked, modal shown by helper
      return;
    }
    if (await isBlockedByActiveGeneration({ accountId: this.props.selectedAccount._id })) {
      return;
    }
    dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    this.setState({ generatePlaybookModal: true });
    // dispatch.lifeCycle.setSelectedPracticeLibraryData({});
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.setArrangementPaneFlag(false);
    dispatch.lifeCycle.modalEditOpen(false);
    dispatch.lifeCycle.showLangingPage(false);
    dispatch.organizationUnit.fetchTeams({
      organizationId: this.props.selectedOrganisation.id,
      accountId: this.props.selectedAccount._id,
    });
  };

  regeneratePlaybook = async (e) => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    let requiredCredits = defaults.playbooksGenerated + (defaults.activitiesGenerated * 100);
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits,
      entity: "Playbooks",
      entityType: "AI Generated Playbook",
    })) {
      // blocked, modal shown by helper
      return;
    }
    if (await isBlockedByActiveGeneration({ accountId: this.props.selectedAccount._id })) {
      return;
    }
    let message = (
      <div className="confirmMessage">
        <h3>Regenerate Playbook</h3>
        <label>{this.props.selectedPracticeLibrary.name}</label>
        <p>Are you sure to Regenerate this Playbook?</p>
        <span>This action is not reversible</span>
      </div>
    );
    toastr.confirm(message, {
      onOk: async () => {
        this.setState({ regeneratePlaybookFlag: true });
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        let topic = this.props.selectedPracticeLibrary.genParams.find(
          (params) => params.key === "topic"
        );
        const payload = {
          topic: topic
            ? topic.value.replace(/\s*\(\d+\)$/, "")
            : this.props.selectedPracticeLibrary.name.replace(
                /\s*\(\d+\)$/,
                ""
              ),
          attributes: this.props.selectedPracticeLibrary.genParams.map(
            (elem) => {
              return {
                key: elem.key,
                value: elem.value,
              };
            }
          ),
          baseCategory: this.props.selectedPracticeLibrary.baseCategory,
          category: this.props.selectedPracticeLibrary.category,
          subCategory: this.props.selectedPracticeLibrary.subCategory,
          playbook: this.props.selectedPracticeLibrary,
        };
        await dispatch.lifeCycle.getPlayBookDescription(payload);
        dispatch.lifeCycle.setArrangementPaneFlag(false);
        this.setState({ regeneratePlaybookFlag: false });
      },
    });
  };

  closeGeneratePlaybookModal = (open) => {
    this.setState({ generatePlaybookModal: open });
  };
  deletePlaybook = (e) => {
    let message = (
      <div className="confirmMessage">
        <h3>Delete Playbook</h3>
        <label>{this.props.selectedPracticeLibrary.name}</label>
        <p>Are you sure to remove this Playbook?</p>
        <span>This action is not reversible</span>
      </div>
    );
    toastr.confirm(message, {
      onOk: () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        let payload = {};
        payload.type = "removePack";
        payload.packid = this.props.selectedPracticeLibrary._id;
        payload.accountId = this.props.selectedAccount._id;
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.userid = this.props.user._id;
        payload.baseId = this.props.selectedPracticeLibrary.baseId;
        dispatch.lifeCycle.deletePlaybook(payload);
        dispatch.lifeCycle.setArrangementPaneFlag(false);
      },
    });
  };

  getPlaybookToExport = async () => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookExported,
      entity: "Playbooks",
      entityType: "Export Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      dispatch.app.setCollapsedResourcePaneIndexTemp(null);

      let message = (
        <div className="confirmMessage">
          <h3>Export to Playbook</h3>
          <label>{this.props.selectedPracticeLibrary.name}</label>
          <p>Are you sure you want to export this playbook?</p>
          <span style={{ color: "#a9a9a9" }}>
            This action will not export comments added at
            playbook/activity level.
          </span>
        </div>
      );
      toastr.confirm(message, {
        okText: "Export ",
        onOk: async () => {
          await dispatch.lifeCycle.getPlaybookToExport(
            this.props.selectedPracticeLibrary._id
          );
          var dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(this.props.playbookToExport));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataStr);
          } else {
            //for firfox/chrome
            let link = document.createElement("a");
            link.href = dataStr;
            link.download = this.props.selectedPracticeLibrary.name + ".playbook";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        },
      });
    }
  };

  getPlaybookAsExcel = async () => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookExported,
      entity: "Playbooks",
      entityType: "Export Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      this.setState({ showExcelOptions: false })
      this.setState({excelExport: true})
    }
  }
  getPlaybookAsWord = async () => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookExported,
      entity: "Playbooks",
      entityType: "Export Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      let message = (
        <div className="confirmMessage">
          <h3>Export to Word</h3>
          <label>{this.props.selectedPracticeLibrary.name}</label>
          <p>Are you sure you want to export this playbook?</p>
          <span style={{ color: "#a9a9a9" }}>
            This action will not export references, comments attachments added at
            playbook/activity level.
          </span>
        </div>
      );
      toastr.confirm(message, {
        okText: "Export ",
        onOk: async () => {
          await dispatch.lifeCycle.getPlaybookAsWord(
            this.props.selectedPracticeLibrary._id
          );
        },
      });
    }
  };
  stopLoader = () => {
    this.setState({ processing: false });
    // const { history } = this.props;
    // history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_pb`);
  };

  stopCopyLoader = () => {
    this.setState({ copying: false });
  };

  hideResourcePane = async () => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookCreated,
      entity: "Playbooks",
      entityType: "Import Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
      await dispatch.lifeCycle.splitAt("60%");
    }
  };

  async fileUploaded(data) {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookCreated,
      entity: "Playbooks",
      entityType: "Import Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      if (data.target.files[0].name.split(".").pop() === "playbook") {
        this.setState({ processing: true });
        var fileToLoad = data.target.files[0];
        let selectedOrganisation = this.props.selectedOrganisation;
        var fileReader = new FileReader();

        fileReader.onload = async (fileLoadedEvent) => {
          if (fileLoadedEvent.target.result) {
            await dispatch.lifeCycle.decodePlaybook({
              data: fileLoadedEvent.target.result,
              organizationId: selectedOrganisation.id,
              accountId: this.props.accountId,
            });
            this.setState({ fileData: fileLoadedEvent.target.result });
            this.setState({ playbookInfoModal: true });
            this.stopLoader();
          } else {
            toastr.error("Message", "Invalid File.");
            this.stopLoader();
          }
        };

        fileReader.readAsText(fileToLoad, "UTF-8");
        data.target.value = null;
      } else {
        toastr.error("Message", "Invalid File.");
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isPlaybookImported) {
      //  dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
      dispatch.lifeCycle.isPlaybookImportLoading(false);
      this.stopLoader();
    }
  }

  makeDuplicate() {
    //dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    this.setState({ copying: true });
    let activityObj = Object.assign(
      {},
      this.props.selectedPracticeFlowActivity
    );
    dispatch.lifeCycle.duplicateActivity(activityObj._id);
  }

  handleCopyPlaybookModal = async (open) => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookCreated,
      entity: "Playbooks",
      entityType: "Copy Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
      dispatch.lifeCycle.showResourecePane(null);
      this.setState({ openCopyPlaybook: open });
    }
  };
  closeInfoModal = () => {
    this.setState({ playbookInfoModal: false });
  };
  closeExcelExportModal = () => {
    this.setState({excelExport: false});
  };
  submitInfoModal = async (data) => {
    const payload = {
      categories: data,
      data: this.state.fileData,
      organizationId: this.props.selectedOrganisation.id,
      accountId: this.props.accountId,
    };
    this.closeInfoModal();
    await dispatch.lifeCycle.importPlaybook(payload);
  };
  isDesigner = () => {
    const loggdinUserId = this.props.user.email;
    let author =
      this.props.selectedPracticeLibrary &&
      this.props.selectedPracticeLibrary.participants &&
      this.props.selectedPracticeLibrary.participants.filter((participant) => {
        return participant.role === "author";
      });
    if (author && author.length > 0) {
      return author.find((author) => author.email === loggdinUserId);
    }
    return null;
  };

  isContributor = () => {
    const loggdinUserId = this.props.user.email;
    let contributor =
      this.props.selectedPracticeLibrary &&
      this.props.selectedPracticeLibrary.participants &&
      this.props.selectedPracticeLibrary.participants.filter((participant) => {
        return participant.role === "contributor";
      });
    if (contributor && contributor.length > 0) {
      return contributor.find(
        (contributor) => contributor.email === loggdinUserId
      );
    }
    return null;
  };

  isAuthor = () => {
    // const loggdinUserId = this.props.user._id;
    let authors =
      this.props.currentOrganization &&
      this.props.currentOrganization.users &&
      this.props.currentOrganization.users.filter(
        (el) =>
          el.accountUserId === this.props.user._id &&
          el.role === "workspaceOwner"
      );
    if (authors && authors.length > 0) {
      return true;
    }
    return null;
  };
  upgradeVersion = async (e) => {
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.playbookCreated,
      entity: "Playbooks",
      entityType: "Version Playbook",
    })) {
      // blocked, modal shown by helper
    } else {
      let newversion = this.props.selectedPracticeLibrary.version.split(".");
      let a = newversion.map(function (item, index) {
        return index === 1 ? parseInt(item) + 1 : item;
      });
      let message = (
        <div className="confirmMessage">
          <h3>Create New Version</h3>
          <label>{this.props.selectedPracticeLibrary.name}</label>
          <h4>Do you want to create a new version of this playbook?</h4>
          <p>This will create a new version {a.join(".")} of this playbook</p>
        </div>
      );
      toastr.confirm(message, {
        onOk: async () => {
          let payload = {
            _id: this.props.selectedPracticeLibrary._id,
            organizationId: this.props.selectedPracticeLibrary.organizationId,
            accountId: this.props.selectedPracticeLibrary.accountId,
            appendVersionToPlaybookName: true,
          };
          await dispatch.lifeCycle.upgradeVersion(payload);
        },
      });
    }
  };
  activitiesGenerationInProgress = () => {
    // Destructure props for clarity
    const selectedActivity = this.props.selectedPracticeFlowActivity;
    const selectedLibrary = this.props.selectedPracticeLibrary;

    // Basic validations
    if (!selectedActivity || !selectedLibrary) {
      // console.log("No selected activity or library found.");
      return false;
    }

    const generatingActivities = selectedLibrary.generatingActivities || [];
    if (
      !Array.isArray(generatingActivities) ||
      generatingActivities.length === 0
    ) {
      // console.log("No generating activities found.");
      return false;
    }

    // Convert selected activity ID to string if available
    const selectedActivityId = selectedActivity._id
      ? selectedActivity._id.toString()
      : "";
    // console.log("Selected Activity ID:", selectedActivityId);

    // 1) Direct check: if the selected activity is in generatingActivities
    if (generatingActivities.indexOf(selectedActivityId) !== -1) {
      // console.log("Selected activity is generating.");
      return true;
    }

    // 2) If it's a leaf node, it's not generating
    if (selectedActivity.isLeafNode) {
      // console.log("Leaf node activity is not generating.");
      return false;
    }

    // 3) If it's a parent node, check all child activities
    if (selectedActivity.isParentNode) {
      // Attempt to find the corresponding phase/activity in the library
      let matchingPhase = null;
      if (selectedLibrary.activities && selectedLibrary.activities.length) {
        for (let i = 0; i < selectedLibrary.activities.length; i++) {
          let activity = selectedLibrary.activities[i];
          if (activity._id && activity._id.toString() === selectedActivityId) {
            matchingPhase = activity;
            break;
          }
        }
      }
      // console.log("Matching phase:", matchingPhase);

      // Helper function to gather all child activity IDs from a phase
      const getChildActivityIds = function (phase) {
        const childIds = [];
        if (phase.activities && phase.activities.length) {
          for (let j = 0; j < phase.activities.length; j++) {
            let stage = phase.activities[j];
            if (stage.activities && stage.activities.length) {
              for (let k = 0; k < stage.activities.length; k++) {
                let childActivity = stage.activities[k];
                if (childActivity._id) {
                  childIds.push(childActivity._id.toString());
                }
              }
            }
          }
        }
        return childIds;
      };

      if (matchingPhase) {
        const allChildActivityIds = getChildActivityIds(matchingPhase);
        // console.log("All child activity IDs:", allChildActivityIds);

        // Check if any child is generating
        for (let m = 0; m < allChildActivityIds.length; m++) {
          if (generatingActivities.indexOf(allChildActivityIds[m]) !== -1) {
            // console.log("One or more child activities are generating.");
            return true;
          }
        }
      } else {
        // If no matching phase is found, fall back to selectedActivity.activities
        if (
          selectedActivity.activities &&
          selectedActivity.activities.length > 0
        ) {
          // console.log("Using selectedActivity.activities as fallback.");
          for (let n = 0; n < selectedActivity.activities.length; n++) {
            let id = selectedActivity.activities[n];
            // Handle if activity is an object with an _id or a plain ID
            if (typeof id === "object" && id._id) {
              id = id._id.toString();
            } else {
              id = id.toString();
            }
            if (generatingActivities.indexOf(id) !== -1) {
              // console.log("One or more fallback child activities are generating.");
              return true;
            }
          }
        }
      }
    }

    // console.log("No activities are generating.");
    return false;
  };

  render() {
    let versionButton = false;
    const scope = this.props.selectedPracticeLibrary.scope;
    const status = this.props.selectedPracticeLibrary.status;
    const integrate =
      this.props.selectedAccount.integrations &&
      this.props.selectedAccount.integrations.some(
        (int) => int.isActive && int.id.id === "openai"
      );
    if (this.isAuthor() || this.isDesigner() || this.isContributor()) {
      if (scope === "Private" && status == 4) {
        versionButton = true;
      }
    }

    if (!_.isEmpty(this.props.selectedPracticeLibrary)) {
      let resultPlaybooks = this.props.PracticeLibrarys.filter(
        (playbook) =>
          playbook.baseId === this.props.selectedPracticeLibrary.baseId &&
          playbook.status === 0
      );
      if (resultPlaybooks.length !== 0) {
        versionButton = false;
      }
    }
    if (
      this.props.allPlaybooksFromBaseId &&
      this.props.allPlaybooksFromBaseId.length > 0 &&
      !_.isEmpty(this.props.selectedPracticeLibrary)
    ) {
      let playbbokResult = this.props.allPlaybooksFromBaseId.filter(
        (playbook) =>
          playbook.baseId === this.props.selectedPracticeLibrary.baseId &&
          playbook.status === 0
      );
      if (playbbokResult.length !== 0) {
        versionButton = false;
      }
    }
    let objValidation =
      Object.entries(this.props.selectedPracticeLibrary).length === 0 &&
      this.props.selectedPracticeLibrary.constructor === Object;

    let isAuthorizedToPublish = false;
    let isAuthorizedToCopy = false,
      isAuthorizedToCopyPlaybook = false;
    this.props.selectedPracticeLibrary &&
      this.props.selectedPracticeLibrary.participants &&
      this.props.selectedPracticeLibrary.participants.map((participant) => {
        if (
          this.props.user._id === participant.accountUserId &&
          participant.role === "author"
        ) {
          isAuthorizedToCopy = true;
          if (
            this.props.selectedPracticeLibrary.organizationId &&
            this.props.selectedOrganisation.id.toString() ===
              this.props.selectedPracticeLibrary.organizationId.toString()
          ) {
            isAuthorizedToPublish = true;
            isAuthorizedToCopyPlaybook = true;
          }
        }
        if (
          this.props.user._id === participant.accountUserId &&
          (participant.role === "author" || participant.role === "contributor")
        ) {
          isAuthorizedToCopy = true;
          isAuthorizedToCopyPlaybook = true;
        }
      });
    let isExecutive = false;
    if (
      this.props.selectedPracticeLibrary &&
      this.props.selectedPracticeLibrary.organizationId &&
      this.props.selectedOrganisation.id.toString() ===
        this.props.selectedPracticeLibrary.organizationId.toString()
    ) {
      this.props.selectedAccount &&
        this.props.selectedAccount.users &&
        this.props.selectedAccount.users.map((user) => {
          if (
            user &&
            user.id &&
            user.id.toString() === this.props.user &&
            this.props.user._id.toString() &&
            user.role === "customerAdmin"
          ) {
            isExecutive = true;
          }
        });
      if (!isExecutive) {
        if (
          this.props.selectedOrganisation &&
          this.props.selectedOrganisation.role === "workspaceOwner"
        ) {
          isExecutive = true;
        }
      }
    }
    const isExportDisabled =
      (this.props.selectedPracticeLibrary.playbookGenerationStatus &&
        this.props.selectedPracticeLibrary.playbookGenerationStatus == 1) ||
      objValidation ||
      (!isAuthorizedToPublish &&
        !isExecutive &&
        !(
          this.props.selectedPracticeLibrary.status === 4 &&
          this.props.selectedPracticeLibrary.scope === "Public"
        )) ||
      this.props.selectedPracticeLibrary.status === -1 ||
      this.props.activePageTab == "createPlaybook";

      const isDeleteButtonDisabled = 
        objValidation ||
        (!isAuthorizedToPublish && !isExecutive) ||
        this.props.activePageTab !== "libraryCard";

      //for duplicate
      const isDuplicateButton = 
        !this.props.duplicateIconFlag ||
        !(isAuthorizedToCopy || isExecutive) ||
        this.props.selectedPracticeLibrary.status !== 0 ||
        _.isEmpty(this.props.selectedPracticeFlowActivity) ||
        this.activitiesGenerationInProgress();

      //PlayBook Copy
      const isCopyPlaybookDisabled = 
        (!isAuthorizedToCopyPlaybook && !isExecutive) ||
        objValidation ||
        (this.props.selectedPracticeLibrary.status !== 0 &&
          this.props.selectedPracticeLibrary.status !== 5 &&
          this.isAuthor() &&
          this.props.selectedPracticeLibrary.status !== 4 &&
          this.isAuthor() &&
          this.isDesigner()) ||
        (this.props.selectedPracticeLibrary.playbookGenerationStatus &&
          this.props.selectedPracticeLibrary.playbookGenerationStatus == 1);
    



    return (
      <div className="toolBar header_buttons toolbatInputFile">
        <LoadingComponent
          active={this.state.processing}
          message="Creating Playbook"
        />
        {this.props.ImportPlayBookLoader && (
          <LoadingComponent active={true} message="Importing Playbook" />
        )}
        <Button.Group size="mini" className="mar_Right_5">
          {this.props.activePageTab !== "createPlaybook" && integrate ? (
            <Popup
              trigger={
                <span
                  onMouseEnter={() =>
                    dispatch.app.setHelpContext("Create Playbook")
                  }
                >
                  <Button
                    style={{ width: "135px", whiteSpace: "nowrap" }}
                    icon="plus"
                    labelPosition="left"
                    id="create-playbook"
                    className="clr-blue"
                    content="New Playbook"
                  />
                </span>
              }
              flowing
              hoverable
              on="hover"
              open={this.state.popupOpen}
              onOpen={this.handleOpen}
              onClose={this.handleClose}
              position="bottom center"
            >
              <List selection verticalAlign="middle">
              <List.Item onClick={this.generatePlaybook}>
                <div style={{display:"flex", marginLeft:'-3px'}}>
                  <Image
                    style={{ width: "15px", }}
                    src={generateAi}
                  />
                  <List.Content style={{marginLeft:'7px'}}>Generate with AI</List.Content>
                  </div>
                </List.Item>
                <List.Item onClick={this.createPlaybook}>
                  <Icon
                    name="plus"
                    style={{ fontSize: "12px" }}
                    className="clr-blue"
                  />
                  <List.Content>Create step-by-step</List.Content>
                </List.Item>
              </List>
            </Popup>
          ) : (
            <span>
              {this.props.activePageTab !== "createPlaybook" ? (
                <Popup
                  className="popupStyled"
                  inverted
                  trigger={
                    <span
                      onMouseEnter={() =>
                        dispatch.app.setHelpContext("Create Playbook")
                      }
                    >
                      <Button
                        icon="plus"
                        className="clr-blue"
                        onClick={this.createPlaybook}
                      />
                    </span>
                  }
                  content="Create Playbook"
                />
              ) : (
                <Popup
                  className="popupStyled"
                  inverted
                  trigger={
                    <span
                      onMouseEnter={() =>
                        dispatch.app.setHelpContext("Create Playbook")
                      }
                    >
                      <Button
                        icon="plus"
                        disabled="true"
                        className="clr-blue"
                      />
                    </span>
                  }
                  content="Create Playbook"
                />
              )}
            </span>
          )}
          <Popup
            className="popupStyled z-index-999"
            inverted
            trigger={
              <label
                className={
                  this.props.activePageTab == "createPlaybook"
                    ? "disabledImportIcon"
                    : "exportIcon"
                }
              >
                <Icon
                  onClick={this.hideResourcePane}
                  name="cloud upload"
                  className={`f_16 ${
                    this.props.activePageTab == "createPlaybook"
                      ? "clr-light-blue"
                      : "clr-blue"
                  }`}
                  onMouseEnter={() =>
                    dispatch.app.setHelpContext("Import Playbook")
                  }
                  style={{ verticalAlign: "top", margin: "-2px 0 0 0" }}
                />
                <input
                  type="file"
                  name="file"
                  id="file"
                  className="inputfile"
                  onChange={(e) => this.fileUploaded(e)}
                  accept=".playbook"
                  disabled={this.props.activePageTab == "createPlaybook" || this.props.subscriptionLimitError}
                />
              </label>
            }
            content="Import Playbook"
          />
        </Button.Group>

        <Button.Group size="mini" className="mar_Right_5">
          {/* <Popup className="popupStyled" inverted trigger={
            <span onMouseEnter={() => dispatch.app.setHelpContext("Create Dependency")}>
              {!this.props.enableLinkActivity && <Button icon='linkify' style={{ color: "green" }} className={this.props.selectedPracticeLibrary.status !== 0 || this.props.showResourecePaneFlag !== "PracticeCommunitySwimLineCommanPane" || this.props.arrangementPaneActiveButtonFlag !== "Sequence" ? "" : ""} onClick={this.enableLinking}
                disabled={this.props.selectedPracticeLibrary.status !== 0 || !(isAuthorizedToCopy || isExecutive) || _.isEmpty(this.props.selectedPracticeFlowActivity) || this.props.selectedPracticeFlowActivity.isParentNode || this.props.arrangementPaneActiveButtonFlag !== "Sequence"} />}

              {this.props.enableLinkActivity && <Button icon='linkify' className="clr-green toggleOn" onClick={this.disableLinking}
                disabled={this.props.selectedPracticeLibrary.status !== 0 || !(isAuthorizedToCopy || isExecutive) || _.isEmpty(this.props.selectedPracticeFlowActivity) || this.props.arrangementPaneActiveButtonFlag !== "Sequence"} />}
            </span>
          }
            content='Dependency'
          /> */}
          {this.props.arrangementPaneActiveButtonFlag !== 0 &&
            this.props.arrangementPaneActiveButtonFlag !== "Define" && (
              <Popup
              className="popupStyled"
              inverted
              trigger={
                <span
                  onMouseEnter={() =>
                    dispatch.app.setHelpContext("Copy Activities")
                  }
                >
                  <Button
                    icon="copy"
                    className="clr-green"
                    onClick={() => this.makeDuplicate()}
                    disabled={isDuplicateButton}
                  />
                </span>
              }
              content={!isDuplicateButton ? "Duplicate" : null}
              disabled={isDuplicateButton}
            />
            )}
          {/* {(this.props.arrangementPaneActiveButtonFlag === 0 || this.props.arrangementPaneActiveButtonFlag === 'Define') && <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Copy Playbook")}><Button icon='copy' className="clr-green" onClick={() => this.handleCopyPlaybookModal(true)} disabled={(!isAuthorizedToCopyPlaybook && !isExecutive) || objValidation || this.props.selectedPracticeLibrary.status !== 0} /></span>}
            content='Copy Playbook'
          />} */}
          {(this.props.arrangementPaneActiveButtonFlag === 0 ||
            this.props.arrangementPaneActiveButtonFlag === "Define") && (
              <Popup
              className="popupStyled"
              inverted
              trigger={
                <span
                  onMouseEnter={() =>
                    dispatch.app.setHelpContext("Copy Playbook")
                  }
                >
                  <Button
                    icon="copy"
                    className="clr-green"
                    onClick={() => this.handleCopyPlaybookModal(true)}
                    disabled={isCopyPlaybookDisabled}
                  />
                </span>
              }
              content={!isCopyPlaybookDisabled ? "Copy Playbook" : null}
              disabled={isCopyPlaybookDisabled}
            />
          )}
          {!(
            objValidation ||
            (!isAuthorizedToPublish &&
              !isExecutive &&
              !(
                this.props.selectedPracticeLibrary.status === 4 &&
                this.props.selectedPracticeLibrary.scope === "Public"
              )) ||
            this.props.activePageTab == "createPlaybook"
          ) ? (
            isExportDisabled ? (
              <span>
                <Button
                  icon={<Icon name="cloud download" className="f_16" />}
                  className="clr-green"
                  disabled
                />
              </span>
            ) : (
              <Popup
                trigger={
                  <span
                    onMouseEnter={() =>
                      dispatch.app.setHelpContext("Export Playbook")
                    }
                  >
                    <Button
                      icon={<Icon name="cloud download" className="f_16" />}
                      className="clr-green"
                      disabled={
                        (this.props.selectedPracticeLibrary
                          .playbookGenerationStatus &&
                          this.props.selectedPracticeLibrary
                            .playbookGenerationStatus == 1) ||
                        objValidation ||
                        (!isAuthorizedToPublish &&
                          !isExecutive &&
                          !(
                            this.props.selectedPracticeLibrary.status === 4 &&
                            this.props.selectedPracticeLibrary.scope ===
                              "Public"
                          )) ||
                        this.props.selectedPracticeLibrary.status === -1 ||
                        this.props.activePageTab == "createPlaybook"
                      }
                    />
                  </span>
                }
                hoverable
                flowing
                on="hover"
                onMouseEnter={() => this.setState({ showExcelOptions: false })}
                onMouseLeave={() => this.setState({ showExcelOptions: false })}
                // mouseEnterDelay={200}
                // mouseLeaveDelay={1000}
              >
                <Header className="f_14 mar_0">Export as</Header>
                <Divider style={{ margin: "5px 0" }} />
                <List selection verticalAlign="middle">
                  <List.Item
                    onMouseEnter={() =>
                      this.setState({ showExcelOptions: false })
                    }
                    onMouseLeave={() =>
                      this.setState({ showExcelOptions: false })
                    }
                    disabled={
                      this.props.selectedPracticeLibrary
                        .playbookGenerationStatus &&
                      this.props.selectedPracticeLibrary
                        .playbookGenerationStatus == 1
                    }
                    onClick={this.getPlaybookToExport}
                  >
                    <Image
                      disabled={
                        this.props.selectedPracticeLibrary
                          .playbookGenerationStatus &&
                        this.props.selectedPracticeLibrary
                          .playbookGenerationStatus == 1
                      }
                      style={{ height: "16px" }}
                      src={designerImage}
                    />
                    <List.Content>Playbook</List.Content>
                  </List.Item>
                  <List.Item
                    onMouseEnter={() =>
                      this.setState({ showExcelOptions: false })
                    }
                    onMouseLeave={() =>
                      this.setState({ showExcelOptions: false })
                    }
                    onClick={this.getPlaybookAsWord}
                  >
                    <Image style={{ height: "16px" }} src={wordImage} />
                    <List.Content>Word</List.Content>
                  </List.Item>
                  {/* <List.Item>
                  <List.Content>
                      <Popup
                        trigger={
                          <span
                            onMouseEnter={() =>
                              dispatch.app.setHelpContext("Export Playbook")
                            }
                            style={{display: "flex"}}
                          >
                            <Image style={{ height: "16px", marginRight: "8px" }} src={excelImage} />Excel
                          </span>
                        }
                        flowing
                        hoverable
                        on="hover"
                        position="right center"
                        size="mini"
                        mouseEnterDelay={200}
                        mouseLeaveDelay={1000}
                      >
                        <List selection verticalAlign="middle">
                          <List.Item onClick={(e)=> {e.stopPropagation(); this.getPlaybookAsExcel}}>
                            <Image src={excelImage} style={{ height: "12px", marginRight: "8px" }} />
                            <List.Content>
                              <List.Header style={{fontSize:"8px"}}>Playbook Details</List.Header>
                            </List.Content>
                          </List.Item>

                          <Divider style={{ margin: "6px 0" }} />

                          <List.Item disabled={true} onClick={this.getPlaybookKnowledgeBanksAsExcel}>
                            <Image src={excelImage} style={{ height: "12px", marginRight: "8px" }} />
                            <List.Content>
                              <List.Header style={{fontSize:"8px"}}>Knowledge Base</List.Header>
                            </List.Content>
                          </List.Item>
                        </List>
                      </Popup>
                  </List.Content>
                </List.Item> */}
                  <List.Item
                    flowing
                    hoverable
                    on="hover"
                    onMouseEnter={() =>
                      this.setState({ showExcelOptions: true })
                    }
                    // onMouseLeave={() => this.setState({ showExcelOptions: false })}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Image
                      style={{ height: "16px", marginRight: "8px" }}
                      src={excelImage}
                    />
                    <div style={{ position: "relative" }}>
                      <List.Content>Excel</List.Content>
                    </div>
                    {this.state.showExcelOptions && (
                      <div className="excel‐submenu">
                        <List selection verticalAlign="middle">
                          <List.Item onClick={this.getPlaybookAsExcel}>
                            <Image
                              src={excelImage}
                              style={{ height: "12px", marginRight: "8px" }}
                            />
                            <List.Content>
                              <List.Header style={{ fontSize: "8px" }}>
                                Playbook Details
                              </List.Header>
                            </List.Content>
                          </List.Item>

                          <Divider style={{ margin: "6px 0" }} />

                          <List.Item
                            disabled
                            onClick={this.getPlaybookKnowledgeBanksAsExcel}
                            style={{
                              opacity: 0.5,
                              cursor: "not-allowed", // shows the "no" symbol
                              pointerEvents: "none", // disables click events
                            }}
                          >
                            <Image
                              src={excelImage}
                              style={{ height: "12px", marginRight: "8px" }}
                            />
                            <List.Content>
                              <List.Header style={{ fontSize: "8px" }}>
                                Knowledge Base
                              </List.Header>
                            </List.Content>
                          </List.Item>
                        </List>
                      </div>
                    )}
                  </List.Item>
                </List>
              </Popup>
            )
          ) : (
            <span
              onMouseEnter={() =>
                dispatch.app.setHelpContext("Export Playbook")
              }
            >
              <Button
                icon={<Icon name="cloud download" className="f_16" />}
                className="clr-green"
                disabled={
                  objValidation ||
                  !isAuthorizedToPublish ||
                  this.props.activePageTab == "createPlaybook"
                }
              />
            </span>
          )}
        </Button.Group>

        {/* create new version  */}
        {scope === "Private" ? (
          <Button.Group size="mini">
            <Popup
              className="popupStyled"
              inverted
              trigger={
                <span
                  onMouseEnter={() =>
                    dispatch.app.setHelpContext("Create New Version")
                  }
                >
                  <Button
                    icon="calendar plus outline"
                    className="clr-green"
                    onClick={this.upgradeVersion}
                    disabled={!versionButton}
                    onMouseEnter={() =>
                      dispatch.app.setHelpContext("Create New Version")
                    }
                  />
                </span>
              }
              content={!versionButton ? null : "Create New Version"}
              disabled={!versionButton}
            />
          </Button.Group>
        ) : null}

        <Button.Group size="mini">
          {/* <Popup
            className="popupStyled"
            inverted
            trigger={
              <span>
                <Button
                   icon="refresh"
                  className="clr-green"
                  onClick={this.regeneratePlaybook}
                  disabled={!this.props.selectedPracticeLibrary || !this.props.selectedPracticeLibrary.playbookGenerationStatus || this.props.selectedPracticeLibrary.playbookGenerationStatus !== -1 || this.state.regeneratePlaybookFlag}
                >
                </Button>
              </span>
            }
            content="Regenerate Playbook"
          /> */}
          <Popup
          className="popupStyled"
          inverted
          trigger={
            <span
              onMouseEnter={() =>
                dispatch.app.setHelpContext("Delete Playbook")
              }
            >
              <Button
                icon="trash"
                className="clr-orange"
                onClick={this.deletePlaybook}
                disabled={isDeleteButtonDisabled}
                onMouseEnter={() =>
                  dispatch.app.setHelpContext("Delete Playbook")
                }
              />
            </span>
          }
          content={!isDeleteButtonDisabled ? "Delete Playbook" : null}
          disabled={isDeleteButtonDisabled}
        />
        </Button.Group>
        {this.state.generatePlaybookModal ? (
          <GeneratePlaybookModal
            publishAllOpen={this.state.generatePlaybookModal}
            closeGeneratePlaybookModal={this.closeGeneratePlaybookModal}
            playbook={this.props.playbook}
            history={this.props.history}
            playbookGenerationIndex={this.props.playbookGenerationIndex}
            playbookGenerationState={this.props.playbookGenerationState}
            percentageGenerationComplete={
              this.props.percentageGenerationComplete
            }
            categoryList={this.props.allCategoryList}
            selectedAccount={this.props.selectedAccount}
            loadingGetContentListData={this.props.loadingGetContentListData}
            {...this.props}
          />
        ) : null}
        {this.state.openCopyPlaybook ? (
          <CopyPlaybookModal
            allList={this.props.allList}
            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
            selectedSubOrg={this.props.selectedSubOrg}
            openCopyPlaybook={this.state.openCopyPlaybook}
            handleCopyPlaybookModal={this.handleCopyPlaybookModal}
            routeParams={this.props.routeParams}
            validPracticeName={this.props.validPracticeName}
            selectedOrganisation={this.props.selectedOrganisation}
            user={this.props.user}
          />
        ) : null}
        {this.state.playbookInfoModal && (
          <PlaybookInfoModal
            playbookInfoModal={this.state.playbookInfoModal}
            playbook={this.props.decodedPlaybook}
            closeInfoModal={this.closeInfoModal}
            submitModal={this.submitInfoModal}
            categoryList={this.props.allCategoryList}
            selectedAccount={this.props.selectedAccount}
          />
        )}
        {this.state.excelExport && ( 
          <ExcelPlaybookConfirmationModal
            open={this.state.excelExport}
            closeExcelExportModal={this.closeExcelExportModal}
            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          />
        )}
      </div>
    );
  }
}

export default ToolbarDesigner;
